export enum TimeFormatEnum {
    TwelveHour = '12h',
    TwentyFourHour = '24h',
}
